const testimonials = [
  {
    name: "Jessica M.",
    location: "Smyrna, GA",
    rating: 5,
    text: "I had a family cruise to the Caribbean in 8 days and realized my passport had expired. Fast Passport Center got me sorted in 4 days. I shipped everything from the UPS Store on Windy Hill Road and never had to leave Smyrna. Incredible service.",
    service: "Emergency Passport Renewal",
  },
  {
    name: "Brian T.",
    location: "Vinings, GA",
    rating: 5,
    text: "Business trip to London in 10 days and I lost my passport. I was absolutely panicking. Fast Passport Center walked me through the DS-64, told me exactly what to send, and got my replacement in 6 days. Can't recommend them enough.",
    service: "Lost Passport Replacement",
  },
  {
    name: "Amanda K.",
    location: "Marietta, GA",
    rating: 5,
    text: "After my divorce I needed my name changed on my passport for an international work conference. Fast Passport Center handled everything perfectly and had it back to me in 2 weeks. The checklist they sent was exactly what I needed.",
    service: "Name Change Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function SmyrnaTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Smyrna Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Smyrna, Vinings, Marietta, and Cobb County who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}